<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg my-subscriptions-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark v-on="on" class="navbar-toggler-profile">
                  {{ $t('Профиль') }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>
                      <a @click="sortData('letterTemplateType')">
                        <i class="pro-icon-arrow-bottom1"></i>
                        {{ $t('Тип шаблона') }}
                      </a>
                    </th>
                    <th>
                      {{ $t('Вид подписки') }}
                    </th>
                    <th>
                      {{ $t('Действие') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>{{ item.letter_template_type.transName }}</td>
                    <td>
                      <span v-if="item.npa">
                        {{ $t('НПА') }}:
                        <router-link
                          :title="item.npa.transProjectGoal | strippedContent"
                          active-class="active"
                          :to="$i18nRoute({ name: 'view-npa', params: { id: item.npa.id } })"
                          :key="item.npa.id"
                        >
                          {{ item.npa.transName }}
                        </router-link>


                      </span>
                      <span v-if="item.category">
                        {{ $t('Категория') }}: {{ item.category.transName }}
                      </span>
                      <span v-if="item.developer">
                        {{ $t('Разработчик') }}:
                        <v-icon
                          v-if="item.developer.status === false"
                          class="nv_icon mr-1"
                          x-small
                        />
                        {{ item.developer.transName }}
                      </span>
                      <span v-if="item.keyword">
                        {{ $t('Ключевое слово') }}: {{ item.keyword.transName }}
                      </span>
                    </td>
                    <td>
                      <div class="subscripbe">
                        <a @click="unsubscribe(item.id)">
                          <img src="@/assets/subscibe.png" alt="subscibe" />
                          {{ $t('Отписаться') }}
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div class="private-footer">
                <p>{{ $t('Общее количество подписок') }}: {{ itemsTotal }}</p>
              </div>

              <v-pagination
                v-model="page"
                :length="pagesCount"
                :total-visible="7"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Widget from '@/components/app/Widget'
import Subs from '@/model/subs'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Widget
  },
  data() {
    return {
      breadcrumbs: [],
      items: [],
      sorting: {},
      sortSettings: {
        letterTemplateType: null,
        category: null,
        developer: null,
        keyword: null,
        id: null
      },
      itemsTotal: 0,
      page: 1,
      pagesCount: 1
    }
  },
  watch: {
    $route: 'fetchData',
    page() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.sorting.page = this.page
      Subs.profileSubs(this.sorting)
        .then((response) => {
          this.items = response.items
          const paginator = response.paginationData
          this.itemsTotal = paginator.totalCount
          this.pagesCount = paginator.pageCount
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Профиль'),
              disabled: false,
              href: Trans.currentLocaleUrl + '/profile'
            },
            { text: this.$i18n.t('Все мои подписки'), disabled: true }
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
    },
    unsubscribe(id) {
      this.setLoading(true)
      Subs.unsubscribeNewsletter(id)
        .then((response) => {
          if (response.data.result === 'success') {
            this.fetchData()
            alert(this.$i18n.t('Подписка успешно отменена'))
          }
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
        })
      this.setLoading(false)
    },
    sortData(sortKey) {
      if (
        !this.sortSettings[sortKey] ||
        this.sortSettings[sortKey] === 'desc'
      ) {
        this.sortSettings[sortKey] = 'asc'
      } else {
        this.sortSettings[sortKey] = 'desc'
      }

      this.page = 1

      this.sorting = {
        page: this.page,
        orderBy: sortKey,
        orderDir: this.sortSettings[sortKey]
      }
      this.fetchData()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
